import { Anchor, Box, Nav, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { WebSocketStatus } from '../ui';
import { env } from '../../config/env';
import { useUserStore } from '../../context';

export const FooterNav = observer(() => {
  const userStore = useUserStore();
  const year = new Date().getFullYear();

  return (
    <Nav
      direction="row"
      background={{ color: 'brand-gradient', dark: true }}
      style={{ background: 'var(--brand-gradient)' }}
      justify="center"
      align="center"
      fill="horizontal"
      pad="small"
    >
      <Box width="10%" />
      <Box width="80%" direction="row" justify="center" gap="xsmall">
        <Text size="small" style={{ textTransform: 'uppercase' }} weight={300}>
          Copyright &copy; {year}
        </Text>
        <Anchor href="https://www.aktarytech.com" target="_blank">
          <Text size="small">AktaryTech</Text>
        </Anchor>
      </Box>
      <Box width="10%" align="end">
        {env.nodeEnv === 'development' && userStore.user?.id && <WebSocketStatus />}
      </Box>
    </Nav>
  );
});
